import { MenuItem, TextField, Typography } from '@mui/material'
import { type ReactNode } from 'react'

export interface ScopeOption { value: string, label: string }

interface ScopeFilterOrg {
  value: string
  options: ScopeOption[]
  onChange: (value: string) => void
  testId?: string
}

interface Props {
  levelValue: string
  levelOptions: ScopeOption[]
  onLevelChange: (value: string) => void
  levelTestId?: string
  org?: ScopeFilterOrg
  count?: ReactNode
  countTestId?: string
}

// The "Filter by:" scope selector: a level dropdown, an optional org dropdown, and a trailing
// "N of N" count. Presentational and outlined; shared so the Data Dashboard and the statewide
// Management surface render an identical control.
const selectSx = { backgroundColor: 'var(--white)', '& .MuiOutlinedInput-root': { borderRadius: '8px' } }

export const ScopeFilter = ({ levelValue, levelOptions, onLevelChange, levelTestId, org, count, countTestId }: Props): JSX.Element => (
  <>
    <Typography variant='body2' color='text.secondary'>Filter by:</Typography>
    <TextField
      select size='small' variant='outlined' value={levelValue} data-testid={levelTestId}
      onChange={e => { onLevelChange(e.target.value) }}
      sx={{ ...selectSx, minWidth: 180 }}
    >
      {levelOptions.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
    </TextField>
    {org != null &&
      <TextField
        select size='small' variant='outlined' value={org.value} data-testid={org.testId}
        onChange={e => { org.onChange(e.target.value) }}
        sx={{ ...selectSx, minWidth: 320 }}
      >
        {org.options.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
      </TextField>}
    {count != null &&
      <Typography variant='body2' color='text.secondary' fontStyle='italic' data-testid={countTestId} sx={{ ml: { sm: 'auto' } }}>
        {count}
      </Typography>}
  </>
)
